import Host from "./Host";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import host from "./Host";
import moment from "moment";
import feHost from "./feHost";
import axios from "../../assets/js/AxiosInterceptors";
import store from '../../app/store'
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";
const cookies = new Cookies();
function isNumeric(value) {
  return /^-?\d+$/.test(value);
}
const helpers = {
  getImageUrl: function getImageUrl(image_url) {
    var hostURLParts = Host.split("/");
    var hostURL = hostURLParts[0] + "//" + hostURLParts[2] + "/";
    const fullImageURL = hostURL + "api/public/" + image_url;

    return fullImageURL;
  },
  stringToColour: function stringToColour(str) {
    var colour = "#fff";
    if (str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      colour = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
    }

    return colour;
  },
  recursionCategory: function recursionCategory(data) {
    var parent = [];
    for (let item = 0; item < data.length; item++) {
      var child = {
        name: data[item].name,
        attributes: {
          id: data[item].id,
          color: helpers.stringToColour(data[item].condition_value),
          default_value: data[item].default_value,
          is_mandatory: data[item].is_mandatory,
          is_multiple_select: data[item].is_multiple_select,
          has_condition: data[item].has_condition,
          condition_value: data[item].condition_value,
          field_type_name: data[item]["field_type"].name,
          field_type_has_list: data[item]["field_type"].has_list,
        },
      };

      var children = data[item].children;
      var childrenMapped = null;
      if (children != null && children.length > 0) {
        childrenMapped = recursionCategory(children);
      }
      parent.push({
        ...child,
        children: childrenMapped,
      });
    }
    return parent;
  },
  listToTree: function listToTree(items, id = null, link = "survey_field_id") {
    return items
      .filter((item) => item[link] === id)
      .map((item) => ({
        ...item,
        children: helpers.listToTree(items, item.id),
      }));
  },
  checkDarknessOrLightnessForColor: function checkDarknessOrLightnessForColor(
    color
  ) {
    // Variables for red, green, blue values
    var r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
      // If RGB --> store the red, green, blue values in separate variables
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );

      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      // If hex --> Convert it to RGB: http://gist.github.com/983661
      color = +(
        "0x" + color?.slice(1)?.replace(color.length < 5 && /./g, "$&$&")
      );

      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return false; //light
    } else {
      return true; //dark
    }
  },
  formatDate: function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDateTime: function formatDateTime(date) {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hours = "" + d.getHours(),
        minutes = "" + d.getMinutes(),
        seconds = "" + d.getSeconds();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    if (hours.length < 2) hours = "0" + hours;
    if (minutes.length < 2) minutes = "0" + minutes;
    if (seconds.length < 2) seconds = "0" + seconds;

    return [year, month, day].join("_") + "_" + [hours, minutes, seconds].join("_");
}
,
  formatTime: function formatTime(date) {
    var d = new Date(date),
      hours = d.getHours(),
      min = d.getMinutes(),
      sec = d.getSeconds();

    if (hours < 10) hours = "0" + hours;
    if (min < 10) min = "0" + min;
    if (sec < 10) {
      sec = "0" + sec;
    }

    return [hours, min, sec].join(":");
  },
  getImage: (obj, demourl) => {
    let imageSrc = "";
    if (obj?.image?.image_url)
      imageSrc = helpers.getImageUrl(obj?.image?.image_url);
    else imageSrc = demourl;

    return imageSrc;
  },
  removeForwordSplash: (pathname) => {
    let text = pathname?.replace(/\//g, "");
    return text;
  },
  indianNumbersToArabic: function indianNumbersToArabic(value) {
    return value?.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
  },
  INVALID_TOKEN: function INVALID_TOKEN() {
    return "invalid token";
  },
  http: async function http(
    request,
    options,
    onSuccess,
    onAPIfailure,
    onReloadPress,
    consoleCallName
  ) {
    console.log("###########################################################");
    //  console.log("Accessing :" + Host + request + " token = " + options.headers.jwt);
    await fetch(Host + request, options)
      .then((response) => response.json())
      .then(async (responseJson) => {
        // onSuccess(responseJson)
        //  console.log("Response is " + JSON.stringify(responseJson));
        if (responseJson.status == true) {
          try {
            // console.log("Response is ok for  " + consoleCallName);
            await onSuccess(responseJson);
          } catch (e) {
            console.log(
              "error in response ok for (" + consoleCallName + ") : " + e
            );
          }
        } else if (responseJson.status == false) {
          try {
            console.log(
              "Response is not ok  for " +
              consoleCallName +
              ":\n" +
              JSON.stringify(responseJson)
            );
            await onAPIfailure(responseJson);
            if (responseJson.data.message.text == helpers.INVALID_TOKEN()) {
              console.log(helpers.INVALID_TOKEN());
              // await helpers.reGenerateToken().then(async () => {
              //     await onReloadPress(responseJson)
              // })
            }
          } catch (e) {
            console.log(
              "error in response not ok for (" + consoleCallName + ") : " + e
            );
          }
        }
      })
      .catch((err) => {
        try {
          console.log(err);
          //this.refs.toast.show(I18nManager.isRTL ? ("فشل في الاتصال") : ("Network request failed"), 2000);
          // let isRTL = I18nManager.isRTL;
          // if (isRTL) {
          //     Alert.alert(
          //         "فشل في الاتصال",
          //         "تأكد من الاتصال بالانترنت واعد المحاولة !", [
          //         {
          //             text: "حاول مرة اخرى", onPress: () => {
          //                 onReloadPress()// this.initHome();
          //             }
          //         }
          //     ]);
          // } else {
          //     Alert.alert(
          //         "Connection Failure",
          //         "Make sure you have an internet connection and try again", [
          //         {
          //             text: "Try again", onPress: () => {
          //                 onReloadPress()
          //             }
          //         }
          //     ]);
          // }
          // // this.setState({ isLoading: false, dataLoaded: false });
          // console.log(consoleCallName + ": " + err);
        } catch (e) {
          console.log("error in catch for (" + consoleCallName + ") : " + e);
        }
        // this.loadingHome = false;
      });
    console.log("###########################################################");
  },
  checkIfCustomerHasOpenTask: async function checkIfCustomerHasOpenTask(
    customerId,
    taskType,
    headers
  ) {
    try {
      const apiResult = await axios({
        url: Host + `tasks/check_customer_has_open_task`,
        method: "POST",
        headers: headers,
        data: {
          customerId: customerId,
          taskType: taskType,
        },
      });
      this.handleCheckTokenValid(apiResult);
      if (apiResult.data.status === true) {
        return {
          status: true,
          error: "",
          hasOpenTask: true,
          taskDetails: apiResult.data.data.data,
        };
      } else if (
        apiResult.data.status === false &&
        apiResult.data?.data?.message?.code == 1
      ) {
        return {
          status: false,
          error: "Token expired",
          hasOpenTask: false,
          taskDetails: [],
        };
      }
    } catch (error) {
      return {
        status: false,
        error: error,
        hasOpenTask: false,
        taskDetails: [],
      };
    }
  },
  checkIfTaskHasOpenMissionToday: async function checkIfTaskHasOpenMissionToday(
    task_id,
    executionTime,
    headers
  ) {
    try {
      const apiResult = await axios({
        url: Host + `dnd/check_task_has_opened_mission`,
        method: "POST",
        headers: headers,
        data: {
          task_id: task_id,
          date: executionTime,
        },
      });
      this.handleCheckTokenValid(apiResult);
      if (apiResult.data.status === true) {
        return {
          status: true,
          error: "",
          hasOpenTask: true,
          taskDetails: apiResult.data.data.data,
        };
      } else if (
        apiResult.data.status === false &&
        apiResult.data?.data?.message?.code == 1
      ) {
        return {
          status: false,
          error: "Token expired",
          hasOpenTask: false,
          taskDetails: [],
        };
      }
    } catch (error) {
      return {
        status: false,
        error: error,
        hasOpenTask: false,
        taskDetails: [],
      };
    }
  },
  formatCustomerName: function formatCustomerName(name) {
    var formatedName = "";

    if (name && isNumeric(name.slice(0, 2))) {
      var nameParts = name.split("-");

      if (nameParts.length > 0) {
        nameParts.shift();
        formatedName = nameParts.join(" ");
        formatedName = formatedName.trim();
      } else formatedName = "customer format is not valid";
    } else {
      formatedName = name;
    }
    return formatedName;
  },
  formatDescription: function formatDescription(description) {
    var formatedDescription = "";

    if (description) {
      var descriptionParts = description.split("رقم المخول:");

      if (descriptionParts.length > 1) {
        formatedDescription = descriptionParts[1];
        var sliceLength = 0;
        for (var i = 1; i <= 11; i++) {
          const possibleNumericValue = descriptionParts[1].trim().slice(0, i);
          if (isNumeric(possibleNumericValue)) {
            sliceLength = i;
          }
        }
        formatedDescription = descriptionParts[1].trim().substring(sliceLength);
      } else formatedDescription = description;
    } else {
      formatedDescription = "";
    }
    return formatedDescription;
  },
  sendDocumentToTelegram: async (data, fileName, channleName, id) => {
    const formData = new FormData();

    formData.append("document", data, fileName);
    formData.append("thumb", "https://www.is.iq/assets/images/logo/logo.png");
    formData.append(
      "caption",
      "this Report file is created by " + cookies.get("username")
    );
    try {
      const defaultSettings = JSON.parse(localStorage.getItem("defaultSettings"));
      var selectedTelegramChannel = null
      var chat_id = null
      var channel_id = null;
      var is_user = false;
      defaultSettings &&
        defaultSettings?.length > 0 &&
        defaultSettings?.map((item) => {
          if (item?.field_name == "TELEGRAM_CHANNELS") {
            selectedTelegramChannel = JSON.parse(item?.field_value);
          }
        });
      if (selectedTelegramChannel?.channels?.length)
        selectedTelegramChannel?.channels?.map((item) => {
          if (item?.id == id && item?.channel_id) {
            chat_id = item?.channel_id
          }
        })
    } catch (err) { }

    if (chat_id)
      formData.append("chat_id", chat_id);
    else
      formData.append("chat_id", channleName ? channleName : "@WenkSupport");
    try {
      const response = await fetch(
        `https://api.telegram.org/bot6285346720:AAEg1xIZCs7bKVqBCzrV9ttU-M097yAXDl4/sendDocument`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result && result?.ok && result?.result?.chat && result?.result?.chat?.id) {

        if (selectedTelegramChannel && selectedTelegramChannel?.channels?.length > 0) {
          let arr = []
          selectedTelegramChannel?.channels?.map((item) => {
            if (item?.id == id) {
              arr.push({
                ...item,
                'channel_id': result?.result?.chat?.id
              })
            } else {
              arr.push(item)
            }
          })
          var finalObject = {
            channels: arr
          }
          if (finalObject && finalObject?.channels && finalObject?.channels?.length) {
            store.dispatch(setGlobalLoading(true))
            axios({
              url: Host + "setting/telegram_channel_settings",
              method: "put",
              headers: {
                jwt: cookies.get('token')
              },
              data: finalObject,
            })
              .then((res) => {
                if (res.data.status === true) {
                  store.dispatch(setGlobalLoading(false))
                  helpers.handleFetchStorageData();
                } else if (res.data.status === false) {
                  store.dispatch(setGlobalLoading(false))
                }
              })
              .catch((err) => {
                store.dispatch(setGlobalLoading(false))
              });
          }
        }
      }
      console.log(result);
    } catch (error) {
      console.error(error);
    }
  },
  sendDocumentToTelegramByUserId: async (data, fileName, users) => {
    try {
      users && users?.map(async item => {
        var formData = new FormData();
        formData.append("document", data, fileName);
        formData.append("thumb", "https://www.is.iq/assets/images/logo/logo.png");
        formData.append(
          "caption",
          "this Report file is created by " + cookies.get("username")
        );
        formData.append("chat_id", item?.telegram_id);
        const response = await fetch(
          `https://api.telegram.org/bot6285346720:AAEg1xIZCs7bKVqBCzrV9ttU-M097yAXDl4/sendDocument`,
          {
            method: "POST",
            body: formData,
          }
        );
        const result = await response.json();
        console.log(result);

      })
    } catch (error) {
      console.error(error);
    }
  },
  createFormData: (data) => {
    const formData = new FormData();

    for (const key in data) {
      formData.append(key, data[key]);
    }

    return formData;
  },
  getCurrentTime: (date) => {
    return moment(new Date(date)).format("HH:mm a");
  },
  copyCodeToClipboard: (id) => {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    let value = "";
    value = feHost + `Detials_TaskEdit?id=${id}`;
    dummy.value = value;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  },
  calculateTimeDifference: (start, end) => {
    const startTime = start.getTime();
    const endTime = end.getTime();

    // Check if start is greater than end
    if (startTime > endTime) {
      // Calculate the time difference in milliseconds
      let timeDiff = startTime - endTime;

      // Convert milliseconds to hours and minutes
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      timeDiff -= hours * (1000 * 60 * 60);

      const minutes = Math.floor(timeDiff / (1000 * 60));

      // Return the result as an object with negative values
      return { hours: -hours, minutes: hours ? minutes : -minutes };
    } else {
      // Calculate the time difference in milliseconds
      let timeDiff = endTime - startTime;

      // Convert milliseconds to hours and minutes
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      timeDiff -= hours * (1000 * 60 * 60);

      const minutes = Math.floor(timeDiff / (1000 * 60));

      // Return the result as an object with positive values
      return { hours, minutes };
    }
  },
  checkTextDirection: (value) => {
    if (value && typeof value == "string") {
      const firstCharScript =
        value.charCodeAt(0) >= 0x0600 && value.charCodeAt(0) <= 0x06ff
          ? "rtl"
          : "ltr";
      return firstCharScript;
    } else return "ltr";
  },
  handleCheckTokenValid: (result) => {
    if (result && !result?.data?.status) {
      if (
        result?.data?.data &&
        result?.data?.data?.message?.text &&
        result?.data?.data?.message?.text == "invalid token"
      ) {
        try {
          if (cookies.get("token")) cookies.remove("token");

          console.log("checkToken2");
          if (cookies.get("username")) cookies.remove("username");

          if (localStorage.getItem("userData"))
            localStorage.removeItem("userData");

          if (cookies.get("user_id")) cookies.remove("user_id");

          if (localStorage.getItem("roles")) localStorage.removeItem("roles");

          window.location.href = "/";
        } catch (err) {
          if (cookies.get("token")) cookies.remove("token");
          window.location.href = "/";
        }
      }
    }
  },
  handleSyncCustomers: async () => {
    try {
      store.dispatch(setGlobalLoading(true))
      const apiResult = await axios({
        url: Host + `customers/update_from_erp`,
        method: "GET",
        headers: {
          jwt: cookies.get("token"),
        },
      });
      store.dispatch(setGlobalLoading(false))
      if (apiResult.data.status === true) {
        return true
      } else {
        return false
      }
    } catch (error) {
      store.dispatch(setGlobalLoading(false))
      return false;
    }
  },
  handleFetchStorageData: () => {
    store.dispatch(setGlobalLoading(true))
    var headers = {
      jwt: cookies.get('token'),
    };
    axios({
      url: host + "setting/default_settings",
      method: "get",
      headers: headers,
    })
      .then(res => {
        store.dispatch(setGlobalLoading(false))
        if (res.data.status === true) {
          //console.log(res.data)
          localStorage.setItem("defaultSettings", JSON.stringify(res.data.data));
        } else if (res.data.status === false) {
          localStorage.setItem("defaultSettings", null);
        }
      })
      .catch(err => {
        store.dispatch(setGlobalLoading(false))
      })
  }
};
export default helpers;
